// ค่ากลางของหน้าภาษีส่วนบุคคล จัดหน้าตามแบบ ภ.ง.ด.90/91 บนเว็บ e-Filing ของกรมสรรพากร
// สีเขียวคือสีหลักของแบบยื่นภาษี ส่วนสีฟ้าเป็นสีระบบ ใช้กับการ์ดสรุปในขั้นตอนตรวจสอบข้อมูล

export const RD_GREEN = "#4caf50";
export const RD_GREEN_DARK = "#2e7d32";
export const RD_GREEN_SOFT = "#eaf6ec";

export const cardStyle = {
  background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
  border: "1px solid rgba(18, 125, 255, 0.10)",
};

export const blockStyle = {
  background: "#ffffff",
  border: "1px solid rgba(18, 125, 255, 0.10)",
  borderRadius: 20,
  boxShadow: "0 10px 24px rgba(12, 118, 229, 0.05)",
};

// กรอบขาวขอบบางแบบเดียวกับกล่องกรอกข้อมูลบนเว็บ e-Filing
export const formBlockStyle = {
  background: "#ffffff",
  border: "1px solid #e2e8ec",
  borderRadius: 12,
};

export const WHT_QUICK_RATES = [1, 2, 3, 5, 7, 10];

// แท็กสีของการ์ดรายการเงินได้ที่กรอกเอง ใช้จัดกลุ่มด้วยสายตาเท่านั้น ไม่มีผลต่อการคำนวณ
// dot = สีวงกลมเล็กใต้ตัวลาก, soft = สีพื้นหลังการ์ด (อ่อนมาก) ค่าเริ่มต้น white = ไม่ติดแท็ก
export const INCOME_TAG_COLORS = [
  { value: "white", label: "ไม่ติดแท็ก", dot: "#ffffff", border: "#c0c9d2", soft: "#ffffff" },
  { value: "red", label: "แดง", dot: "#e5534b", border: "#e5534b", soft: "#fdf1f0" },
  { value: "orange", label: "ส้ม", dot: "#ef8c3f", border: "#ef8c3f", soft: "#fef5ed" },
  { value: "yellow", label: "เหลือง", dot: "#e5c02c", border: "#e5c02c", soft: "#fefaea" },
  { value: "green", label: "เขียว", dot: "#4caf50", border: "#4caf50", soft: "#f0f9f1" },
  { value: "blue", label: "ฟ้า", dot: "#3b8fe0", border: "#3b8fe0", soft: "#eff6fd" },
  { value: "purple", label: "ม่วง", dot: "#9061c2", border: "#9061c2", soft: "#f6f1fb" },
  { value: "gray", label: "เทา", dot: "#8a99a8", border: "#8a99a8", soft: "#f5f7f8" },
];

export const DEFAULT_INCOME_TAG_COLOR = "white";

export const incomeTagColor = (value) =>
  INCOME_TAG_COLORS.find((item) => item.value === value) || INCOME_TAG_COLORS[0];

export const THAI_MONTHS = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];

// เปิดมาเห็นสรุปภาษีของปีนั้นก่อน (พร้อมข้อมูลผู้มีเงินได้จากระบบ) แล้วค่อยไล่กรอกเงินได้และค่าลดหย่อน
export const STEPS = [
  { value: 1, key: "review", label: "ตรวจสอบข้อมูล" },
  { value: 2, key: "income", label: "กรอกเงินได้" },
  { value: 3, key: "deduction", label: "กรอกค่าลดหย่อน" },
];

// เรียกขั้นตอนด้วยชื่อแทนเลข ย้ายลำดับทีหลังจะได้ไม่ต้องไล่แก้เลขทั้งไฟล์
export const STEP_KEY = STEPS.reduce((acc, item) => ({ ...acc, [item.key]: item.value }), {});
export const LAST_STEP = STEPS[STEPS.length - 1].value;

export const ADVICE_LEVEL_STYLE = {
  critical: { background: "rgba(229, 83, 83, 0.08)", border: "rgba(229, 83, 83, 0.28)", color: "#b63636", label: "ต้องทำ" },
  action: { background: "rgba(12, 118, 229, 0.07)", border: "rgba(12, 118, 229, 0.22)", color: "#0b4f84", label: "ควรทำ" },
  opportunity: { background: "rgba(47, 181, 114, 0.09)", border: "rgba(47, 181, 114, 0.26)", color: "#188251", label: "โอกาสประหยัดภาษี" },
  info: { background: "rgba(108, 122, 137, 0.08)", border: "rgba(108, 122, 137, 0.20)", color: "#465a6b", label: "ข้อมูล" },
};

export const monthLabel = (periodMonth) => {
  const [year, month] = String(periodMonth || "").split("-");
  const index = Number(month) - 1;
  return THAI_MONTHS[index] ? `${THAI_MONTHS[index]} ${year}` : periodMonth;
};

// แบบยื่นภาษีใช้ปี พ.ศ. ส่วนข้อมูลในระบบเก็บเป็น ค.ศ.
export const toThaiYear = (year) => Number(year || 0) + 543;

// เลขประจำตัวผู้เสียภาษี 13 หลัก แสดงเป็น 1-2345-67890-12-3 เหมือนบนแบบ
export const formatTaxId = (value) => {
  const digits = String(value || "").replace(/[^0-9]/g, "");
  if (digits.length !== 13) return value || "-";
  return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5, 10)}-${digits.slice(10, 12)}-${digits[12]}`;
};

export const emptyIncomeRow = () => ({
  key: `new-${Math.random().toString(36).slice(2, 10)}`,
  uid: null,
  amount: "",
  wht_amount: "",
  payer_tax_id: "",
  payer_name: "",
  income_date: "",
  expense_mode: "standard",
  expense_amount: "",
  note: "",
  detail: "",
  color: DEFAULT_INCOME_TAG_COLOR,
});

// ช่องกรอกตัวเลขแบบมีเครื่องหมายคั่นหลักพัน: state เก็บตัวเลขล้วน (เช่น "1000.5") หน้าจอโชว์ "1,000.5"
export const formatNumberInput = (value) => {
  const raw = String(value ?? "");
  if (raw === "") return "";
  const [intPart, decPart] = raw.split(".");
  const withComma = intPart.replace(/^0+(?=\d)/, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decPart !== undefined ? `${withComma}.${decPart}` : withComma;
};

// แปลงข้อความที่พิมพ์กลับเป็นตัวเลขล้วน: ตัดคอมมา/ตัวอักษรอื่น เหลือจุดทศนิยมจุดเดียว และไม่เกิน 2 ตำแหน่ง
export const parseNumberInput = (text) => {
  let cleaned = String(text ?? "").replace(/[^0-9.]/g, "");
  const firstDot = cleaned.indexOf(".");
  if (firstDot >= 0) cleaned = `${cleaned.slice(0, firstDot + 1)}${cleaned.slice(firstDot + 1).replace(/\./g, "")}`;
  const [intPart, decPart] = cleaned.split(".");
  return decPart !== undefined ? `${intPart}.${decPart.slice(0, 2)}` : intPart;
};
